import React from 'react';
import { LayoutContext } from 'contexts';
import { capitalize } from 'utils';
import { Page } from 'components';
import NeedContext from '../NeedContext';
import { StyledMainGrid } from '../StyledComponents';
import Information from './Information';
import Attachments from '../Attachments';
import ActionButtons from './ActionButtons';

const ViewNeed: React.FC = () => {
  const { setAppTitle } = React.useContext(LayoutContext);
  const { need } = React.useContext(NeedContext);

  const title = React.useMemo(() => {
    if (!need) return '';
    return `${capitalize(need.type)} - ${need.subject}`;
  }, [need]);

  React.useEffect(() => {
    setAppTitle(title);
  }, [title]);

  return (
    <Page
      type="filled"
      title={title}
      headerExtra={<ActionButtons />}
      showBackButton
    >
      <StyledMainGrid>
        <Information />
        <Attachments />
      </StyledMainGrid>
    </Page>
  );
};

export default ViewNeed;
